document.addEventListener('click', function (e) {
  const openTrigger = e.target.closest('[data-modal-open]');
  const closeTrigger = e.target.closest('[data-modal-close]');

  if (openTrigger) {
    const modal = document.getElementById(openTrigger.dataset.modalOpen);
    modal.hidden = false;
    document.body.style.overflow = 'hidden';
  }

  if (closeTrigger) {
    const modal = closeTrigger.closest('.contact-modal');
    modal.hidden = true;
    document.body.style.overflow = '';
  }
});

document.addEventListener('keydown', function (e) {
  if (e.key === 'Escape') {
    document.querySelectorAll('.contact-modal:not([hidden])').forEach(m => {
      m.hidden = true;
      document.body.style.overflow = '';
    });
  }
});